<template>
  <div>
    <div v-if="isOpen" class="overlay" @click="closeModal"></div>

    <transition name="slide">
      <div v-if="isOpen" class="side-modal">
        <b-button class="close-btn" variant="link" @click="closeModal"
          >X</b-button
        >

        <h1 class="center-text">Detalhes do Voucher</h1>
        <!-- {{ voucher }} -->
        <b-row>
          <b-col>
            <h3 class="center-text">#{{ voucher.code }}</h3>
          </b-col>
        </b-row>
        <b-row v-if="voucher.expirationDate" class="mt-4">
          <b-col cols="5">
            <label for="Data de expiração">Data de expiração:</label>
          </b-col>
          <b-col>
            <p v-if="voucher.status == 'Expirado'" class="expired">
              {{ voucher.expirationDate }}
            </p>
            <p v-else class="notExpired">{{ voucher.expirationDate }}</p>
          </b-col>
        </b-row>
        <b-row>
          <b-col cols="5">
            <label for="bonusName">Beneficiário</label>
          </b-col>
          <b-col>
            <p>{{ voucher.bonusName }}</p>
          </b-col>
        </b-row>
        <b-row class="mt-4">
          <b-col cols="5">
            <label for="userCreated">Usuário responsável:</label>
          </b-col>
          <b-col>
            <p>{{ voucher.userCreated }}</p>
          </b-col>
        </b-row>
        <b-row class="mt-4">
          <b-col cols="5">
            <label for="Type">Tipo:</label>
          </b-col>
          <b-col>
            <p>{{ voucher.type }}</p>
          </b-col>
        </b-row>
        <b-row class="mt-4">
          <b-col cols="5">
            <label v-if="voucher.type == 'Desconto'" for="Type">Valor %:</label>
            <label v-else for="Type">Quantidade:</label>
          </b-col>
          <b-col>
            <p>{{ voucher.amount }}</p>
          </b-col>
        </b-row>
        <b-row class="mt-4">
          <b-col cols="5">
            <label for="Type">Total Mensal</label>
          </b-col>
          <b-col>
            <p>{{ voucher.totalUsedMonth }}</p>
          </b-col>
        </b-row>
        <b-row class="mt-4">
          <b-col cols="5">
            <label for="Type">Total Usados:</label>
          </b-col>
          <b-col>
            <p>{{ voucher.totalUsed }}</p>
          </b-col>
        </b-row>
        <b-row class="mt-4">
          <b-col cols="5">
            <h2 for="Type">Histórico de uso:</h2>
          </b-col>
        </b-row>
        <b-row>
          <b-table
            ref="voucherTable"
            :items="voucher.details"
            :fields="fields"
            :filter-debounce="600"
            striped
            hover
          >
          </b-table>
        </b-row>
      </div>
    </transition>
  </div>
</template>

<script>
export default {
  name: "VoucherDetailModal",
  props: {
    isOpen: Boolean,
    voucherId: Number,
  },

  data() {
    return {
      fields: [
        {
          key: "companyDocument",
          label: "CNPJ",
        },
        {
          key: "company",
          label: "Empresa",
        },
        {
          key: "dateUsed",
          label: "Data de uso",
        },
        {
          key: "userUsed",
          label: "Usuário",
        },
      ],
      voucher: {},
    };
  },
  created() {
    this.loadData();
  },
  mounted() {
    document.addEventListener("keydown", this.handleEsc);
  },
  computed: {
    isExpired() {
      let today = new Date();
      if (new Date(this.voucher.expirationDate) < today) return false;
      return true;
    },
  },
  methods: {
    loadData() {
      this.$apiScheduler
        .get(`/voucher/get/${this.voucherId}`)
        .then((response) => {
          this.voucher = response.data;
        });
    },
    closeModal() {
      this.voucher = {};
      this.$emit("update:isOpen", false);
    },
    handleEsc(event) {
      console.log("Tecla pressionada:", event.key);
      if (event.key === "Escape") {
        this.closeModal();
      }
    },
  },
  watch: {
    isOpen() {
      if (this.isOpen) {
        this.loadData();
      }
    },
  },
};
</script>

<style scoped>
.expired {
  color: #ff4619 !important;
}
.notExpired {
  color: #9cff19 !important;
}
.overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background: rgba(0, 0, 0, 0.5);
  z-index: 1000;
}

.side-modal {
  position: fixed;
  top: 0;
  right: 0;
  width: 45vw;
  height: 100vh;
  background: #132651;
  box-shadow: -2px 0 10px rgba(0, 0, 0, 0.2);
  z-index: 1001;
  padding: 20px;
  transition: transform 0.3s ease-in-out;
  overflow-y: auto;
}

/* Transição */
.slide-enter-active,
.slide-leave-active {
  transition: transform 0.3s ease-in-out;
}
.center-text {
  text-align: center;
}
.close-btn {
  color: white;
  border: none;
  padding: 5px 10px;
  cursor: pointer;
}
.slide-enter-from,
.slide-leave-to {
  transform: translateX(100%);
}
</style>
